import React from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error) {
    // Only log internally, not exposed to user
    console.error('[ErrorBoundary]', error.message);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#f8f7fb] flex items-center justify-center p-6">
          <div className="max-w-sm w-full text-center">
            <div className="w-20 h-20 rounded-3xl mx-auto mb-5 flex items-center justify-center"
              style={{ background: 'linear-gradient(135deg, #EDE9FE, #c4b5fd)' }}>
              <AlertTriangle className="w-9 h-9 text-[#5B21B6]" />
            </div>
            <h1 className="text-2xl font-extrabold text-[#1E1B4B] mb-2">Something went wrong</h1>
            <p className="text-gray-500 text-sm mb-6 leading-relaxed">
              We ran into a problem loading this page. Don't worry — your data is safe.
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={() => this.setState({ hasError: false, error: null })}
                className="flex items-center gap-2 px-5 py-2.5 rounded-xl border-2 border-[#5B21B6] text-[#5B21B6] font-semibold text-sm hover:bg-purple-50 transition-all"
              >
                <RefreshCw className="w-4 h-4" /> Try again
              </button>
              <button
                onClick={() => { window.location.href = '/'; }}
                className="da-btn-primary flex items-center gap-2 px-5 py-2.5 text-sm"
              >
                <Home className="w-4 h-4" /> Go home
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
